export const convertToBase64FromBlob = async (picBlob, onloadend, onerror) => {
    const reader = new FileReader();
    reader.readAsDataURL(picBlob);

    reader.onloadend = () => {
        const base64data = reader.result;
        onloadend(base64data);
    };
    reader.onerror = e => {
        onerror(e?.message || 'Failed to get FB blob data.');
    };
};

export const convertSingleFileToMult = (file, callback) => {
    // Create a new DataTransfer object
    const dataTransfer = new DataTransfer();
    // Add the File instance to the DataTransfer object
    dataTransfer.items.add(file);

    callback(dataTransfer.files);
};

export const blobsToFileList = (blobs, callback) => {
    // Create a new DataTransfer object
    const dataTransfer = new DataTransfer();

    blobs.forEach((blob, index) => {
        if (blob instanceof Blob) {
            const filename = `file_${index + 1}`;
            const file = new File([blob], filename, { type: blob.type });
            dataTransfer.items.add(file);
        } else {
            console.warn(`Element at index ${index} in 'blobs' is not a Blob and will be skipped.`);
        }
    });

    callback(dataTransfer.files);
};

export const blobToFile = (blob, fileName = 'pic.jpeg', fieldName = 'file') => {
    const formData = new FormData();
    formData.append(fieldName, blob, fileName);
    return formData;
};
